var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftrLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1213 18.5H29V21.5H16.1213L21.0607 26.4393L18.9393 28.5607L10.3787 20L18.9393 11.4393L21.0607 13.5607L16.1213 18.5Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftrLaunch);
export default __webpack_public_path__ + "static/media/leftrLaunch.9d2f52cdd9aba497c15fdb448750ab1f.svg";
export { ForwardRef as ReactComponent };